/**
 * Mainbeauty — form mockup, đếm ngược webinar, popup exit-intent.
 */
import { bindPopupClose, closePopupOnLead, isAnyPopupOpen } from "./mainbt-popup-form.js";

function initForms() {
  if (window.piLeads) return; // plugin Leads tiếp quản việc gửi form

  document.querySelectorAll("[data-pi-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const body = form.querySelector(".pi-form__body");
      const sent = form.querySelector("[data-pi-sent]");
      if (body) body.hidden = true;
      if (sent) sent.hidden = false;

      // Cùng sự kiện plugin phát, để listener (gate, analytics) chạy y hệt.
      const type = form.querySelector('[name="form_type"]');
      const webinar = form.querySelector('[name="webinar_id"]');
      document.dispatchEvent(
        new CustomEvent("pi:lead", {
          detail: {
            formType: type ? type.value : "",
            webinarId: webinar ? webinar.value : "",
            response: null,
          },
        })
      );
    });
  });
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function initCountdowns() {
  const nodes = document.querySelectorAll("[data-pi-countdown]");
  if (!nodes.length) return;

  const tick = () => {
    const now = Date.now();
    nodes.forEach((node) => {
      const target = new Date(node.getAttribute("data-pi-countdown")).getTime();
      if (isNaN(target)) return;
      const diff = Math.max(0, target - now);
      const set = (key, val) => {
        const el = node.querySelector(`[data-cd="${key}"]`);
        if (el) el.textContent = val;
      };
      set("d", Math.floor(diff / 864e5));
      set("h", pad(Math.floor(diff / 36e5) % 24));
      set("m", pad(Math.floor(diff / 6e4) % 60));
      set("s", pad(Math.floor(diff / 1e3) % 60));

      // Về 0 mà trang không tải lại: đồng hồ đứng im ở 00:00:00 trông y như hỏng. Gắn cờ để
      // CSS/module khác đổi cách hiện. Trạng thái THẬT vẫn do server quyết định ở lần tải sau
      // — ở đây chỉ là chuyện hiển thị, không phải chỗ tự phong cho buổi là "đang diễn ra".
      if (diff === 0) node.classList.add("is-ended");
    });
  };

  tick();
  setInterval(tick, 1000);
}

function initExitPopup() {
  const popup = document.querySelector("[data-pi-popup]");
  if (!popup) return;

  // Tối đa 1 lần/ngày mỗi thiết bị: mở popup là ghi ngày hôm nay vào localStorage.
  const STORE_KEY = "piExitPopupSeen";
  const today = () => {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`; // theo giờ máy
  };
  const seenToday = () => {
    try {
      return localStorage.getItem(STORE_KEY) === today();
    } catch (e) {
      return false;
    }
  };
  const markSeen = () => {
    try {
      localStorage.setItem(STORE_KEY, today());
    } catch (e) {
      // localStorage bị chặn (private mode) — bỏ qua, chỉ mất chặn 1 lần/ngày.
    }
  };

  let shown = seenToday(); // đã xem hôm nay → không mở lại
  const open = () => {
    if (shown) return;

    // 🚨 Có popup khác đang mở thì bỏ lượt và KHÔNG markSeen — suất 1 lần/ngày còn nguyên.
    if (isAnyPopupOpen()) return;

    shown = true;
    markSeen();
    popup.classList.add("is-open");
  };
  const close = () => {
    popup.classList.remove("is-open");
  };

  document.addEventListener("mouseout", (e) => {
    if (e.clientY <= 0) open();
  });

  bindPopupClose(popup, "[data-pi-popup-box]", "[data-pi-popup-close]", close);

  // Gửi thành công: đóng popup, nhường chỗ cho modal thông báo chung.
  closePopupOnLead(popup, close);
}

document.addEventListener("DOMContentLoaded", () => {
  initForms();
  initCountdowns();
  initExitPopup();
});
